import { render, staticRenderFns } from "./02.vue?vue&type=template&id=b52c0ca2"
import script from "./02.vue?vue&type=script&lang=ts"
export * from "./02.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports